export enum FieldViewOptionValueTypeEnum {
  showAsTitle = 'showAsTitle',
  showAsMainDate = 'showAsMainDate',
  showAsSubTitle = 'showAsSubTitle',
  showAsEntryPicture = 'showAsEntryPicture',
  showAsCategory = 'showAsCategory',
  showAsSubCategory = 'showAsSubCategory',
  showAsRelationField = 'showAsRelationField',
  showAsMainPhone = 'showAsMainPhone',
  showAsMainNumber = 'showAsMainNumber',
}
